import { render, staticRenderFns } from "./DiscussionList.vue?vue&type=template&id=a59fefac&scoped=true&"
import script from "./DiscussionList.vue?vue&type=script&lang=js&"
export * from "./DiscussionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59fefac",
  null
  
)

export default component.exports